/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single time-series bucket for hooks activity
 */
export type HooksTimeSeriesPoint = {
  /**
   * Bucket start time in Unix nanoseconds (string for JS int64 precision)
   */
  bucketStartNs: string;
  /**
   * Number of events in this bucket
   */
  eventCount: number;
  /**
   * Number of failed hook events in this bucket
   */
  failureCount: number;
  /**
   * Server name
   */
  serverName: string;
  /**
   * User email address
   */
  userEmail: string;
};

/** @internal */
export const HooksTimeSeriesPoint$inboundSchema: z.ZodMiniType<
  HooksTimeSeriesPoint,
  unknown
> = z.pipe(
  z.object({
    bucket_start_ns: z.string(),
    event_count: z.int(),
    failure_count: z.int(),
    server_name: z.string(),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start_ns": "bucketStartNs",
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "server_name": "serverName",
      "user_email": "userEmail",
    });
  }),
);

export function hooksTimeSeriesPointFromJSON(
  jsonString: string,
): SafeParseResult<HooksTimeSeriesPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HooksTimeSeriesPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HooksTimeSeriesPoint' from JSON`,
  );
}
